import script from "./FloatingCallButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingCallButton.vue?vue&type=script&setup=true&lang=js"

import "./FloatingCallButton.vue?vue&type=style&index=0&id=27a9907a&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a9907a"]])

export default __exports__